module.exports = __webpack_public_path__ + "img/0Q3A7086_L.56ee3e10.webp";